// components/ConfirmDeleteModal.js
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react';

const ConfirmDeleteModal = ({ isOpen, onClose, onConfirm, itemName }) => (
    <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
            <ModalHeader>Confirm Deletion</ModalHeader>
            <ModalBody>
                Are you sure you want to delete template <strong>{itemName}</strong>?
            </ModalBody>
            <ModalFooter>
                <Button colorScheme="red" mr={3} onClick={onConfirm}>Delete</Button>
                <Button onClick={onClose}>Cancel</Button>
            </ModalFooter>
        </ModalContent>
    </Modal>
);

export default ConfirmDeleteModal;
